module.exports = __webpack_public_path__ + "static/media/mn.e9719178.svg";